import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IOption } from "@faire/web--source/slate/Input/Dropdown";
import { IBrandLead } from "@faire/web-api--source/indigofair/data/IBrandLead";

export const SOURCE_OPTIONS = (
  strictLocalize: StrictLocalizeFunction
): IOption<IBrandLead.Source>[] => [
  {
    label: strictLocalize({ defaultMessage: "Social Media" }),
    value: IBrandLead.Source.SOCIAL_MEDIA,
  },
  {
    label: strictLocalize({ defaultMessage: "Another Brand" }),
    value: IBrandLead.Source.BRAND_REFERRAL,
  },
  {
    label: strictLocalize({ defaultMessage: "A Retailer" }),
    value: IBrandLead.Source.RETAILER_REFERRAL,
  },
  {
    label: strictLocalize({ defaultMessage: "A Faire employee" }),
    value: IBrandLead.Source.FAIRE_EMPLOYEE,
  },
  {
    label: strictLocalize({ defaultMessage: "Other" }),
    value: IBrandLead.Source.ORGANIC,
  },
];
